import { WebPlugin } from '@capacitor/core';
export class IntentLauncherWeb extends WebPlugin {
    async startActivityAsync(_options) {
        throw this.unavailable('Intent Launcher is not available on web. This feature only works on Android.');
    }
    async openIOSSettings(_options) {
        throw this.unavailable('iOS Settings is not available on web. This feature only works on iOS.');
    }
    async openApplication(_options) {
        throw this.unavailable('Opening applications is not available on web. This feature only works on Android.');
    }
    async getApplicationIconAsync(_options) {
        throw this.unavailable('Getting application icons is not available on web. This feature only works on Android.');
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map